export const FILE_UPLOAD_VALIDATION = {
  FORMAT: 'Only JPEG, JPG, and PNG files are allowed.',
  FILE_SIZE: 'File size should be between 1KB and 8MB.',
};

export const ALLOWED_FORMATS = ['image/jpeg', 'image/jpg', 'image/png'];

export const validateFileSize = (size) => {
  return size >= 1024 && size / 1024 / 1024 <= 8;
};

export const ENTITY_DOC_UPLOAD_VALIDATION = {
  FORMAT: 'Only JPEG, JPG, PNG, and PDF files are allowed.',
  FILE_SIZE: 'File size should be between 1KB and 10MB.',
  PASSWORD_PROTECTED: "Password-protected PDFs weren't added. Please remove the password and try again.",
};

export const ENTITY_DOC_ALLOWED_FORMATS = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];

export const validateEntityDocFileSize = (size) => {
  return size >= 1024 && size / 1024 / 1024 <= 10;
};

// Builds the file name sent to the pre-signed-url request for an entity document:
// the docType short code plus a 1-based index scoped to that docType, e.g. AOI1, AOI2, OTH1,
// with the original extension preserved so S3 stores the correct content type.
export const getIndexedEntityDocFileName = (docTypeValue, fileName, docTypeCounters) => {
  const extension = fileName?.split('.')?.pop()?.toLowerCase();
  const nextIndex = (docTypeCounters[docTypeValue] || 0) + 1;
  docTypeCounters[docTypeValue] = nextIndex;
  return extension ? `${docTypeValue}${nextIndex}.${extension}` : `${docTypeValue}${nextIndex}`;
};
